import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the pt-PT locale.
 */

export const appI18NPtPT: Record<string, any> = {
  '*': {
    saveFileName: 'oss-registo-importacao',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'Está prestes a submeter o seu registo no Regime Importação. Deseja continuar?',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submeter',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'Confirmo que tomei conhecimento dos alertas produzidos pelos dados desta declaração.',
    ["modalYesBtn"]: 'Confirmar',
    ["modalNoBtn"]: 'Cancelar',
    ["schemeConditionsTitle"]: 'Condições de acesso',
    ["schemeConditions"]: `
      <p>Para se registar neste regime deverá confirmar que reúne as seguintes condições:</p>
      <ul>
        <li>É um sujeito passivo que efetua vendas à distância de bens (de produtos não sujeitos a impostos especiais de consumo) importados de países ou territórios terceiros, de valor intrínseco não superior a 150 €.</li>
      </ul>
    `,
  }
};
